import IconInfo from '@/components/icons/IconInfo'
import IconBtseAndOrderly from '@/components/icons/IconBtseAndOrderly'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="app-footer">
      <a
        className="support-center-link"
        target="_blank"
        href="https://orderly.network/docs/home"
        rel="noreferrer"
      >
        <IconInfo className="info-icon" />
        Support
      </a>
      <IconBtseAndOrderly />
    </footer>
  )
}
